module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_0deg.efd9f73a.png";